import React from 'react';
import { Alert } from '@surfline/quiver-react';
import en from '../../intl/translations/en';
import nearbyBuoysPropType from '../../propTypes/nearbyBuoys';

const NearbyBuoysContent = ({ nearbyBuoys }) => (
  <div>
    {(() => {
      if (nearbyBuoys.loading) {
        return <Alert>Loading Buoys...</Alert>;
      }
      if (nearbyBuoys.error) {
        return <Alert type="error">{en.SpotForecast.buoyError.message}</Alert>;
      }
      return nearbyBuoys.data ? (
        <div className="sl-nearby-buoys__content">
          {nearbyBuoys.data.map(buoyData => (
            <a
              key={buoyData.url}
              alt="buoylink"
              href={buoyData.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img key={buoyData.img} alt="buoy" src={buoyData.img} />
            </a>
          ))}
        </div>
      ) : null;
    })()}
  </div>
);

NearbyBuoysContent.propTypes = {
  nearbyBuoys: nearbyBuoysPropType.isRequired,
};
export default NearbyBuoysContent;
